(function ($) {
	'use strict';

	$(function () {
		const $trigger = $('.js-search-trigger');
		const $body = $('.js-search-body');
		const $input = $('[type="search"]', $body);
		const $close = $('.js-search-close');
		const activeClass = 'site-search--is-active';
		const timeout = 250; // wait for css animation to finish

		$trigger.on('click', function () {
			const $nextBody = $(this).next($body);

			$nextBody.toggleClass(activeClass);

			if ($nextBody.hasClass(activeClass)) {
				setTimeout(function () {
					$input.trigger('focus');
				}, timeout);
			}
		});

		$close.on('click', function () {
			$(this).closest($body).removeClass(activeClass);
		});
	});
})(jQuery);
